
import * as React from 'react';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import { DefaultComponentProps } from './defaultcomponent';
import { DefaultCSSStyle } from './defaultcss';

export class DefaultViewImpl extends UIComponentViewImpl<UIDataModel>
{
    draw(props: DefaultComponentProps, state: UIComponentState, cssStyle: DefaultCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
              {props.status}
            </>);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/default/defaultview.tsx